import styled from '@emotion/styled';
import { m } from 'framer-motion';
import { getClampFullRange } from '~/theme';
import { scrollbarThin } from '~/shared/utils/styled';
import { storeFadeIndicatorHeight } from '../ReserveSectionStores/styled';
import { Text } from '~/shared/components';
import { StockAvailabilityStatus } from '~/lib/data-contract';
import { switchProp } from 'styled-tools';

export const StyledReservationStores = styled.ul({
    display: 'flex',
    flexDirection: 'column',
    padding: `${storeFadeIndicatorHeight / 2}px 0`,
    margin: '1px 0', // fix weird visual bug, where the scrollIndicators does not cover all content
    height: 325,
    overflowY: 'scroll',
    ...scrollbarThin,
});

export const StyledReservationStore = styled(m.li)(({ theme }) => ({
    padding: `${getClampFullRange(theme.spacesRaw[1], theme.spacesRaw[2])} ${theme.spaces[3]}`,
    paddingLeft: 0,
}));

export const StyledReservationRadioLabelContent = styled.div(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    gap: `${theme.spaces[2]} ${theme.spaces[3]}`,
    alignItems: 'center',
}));

export const StyledReservationStoreInfo = styled.div(({ theme }) => ({
    display: 'grid',
    marginRight: theme.spaces[3],
}));

export const StyledStoreNameWrapper = styled.div({
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
});

export const StyledOpeningHoursWrapper = styled.div({
    gridColumn: '1 / span 2',
});

export const StyledStockText = styled(Text)<{ stockStatus?: StockAvailabilityStatus }>(
    switchProp('stockStatus', {
        0: ({ theme }) => ({
            color: theme.colors.error,
        }),
        1: ({ theme }) => ({
            color: theme.colors.warning,
        }),
        2: ({ theme }) => ({
            color: theme.colors.success,
        }),
    })
);
